import styles from "./SearchLeadFormSection.module.scss";
import Image from "@Components/Image";
import wrapperHOC from "@Utils/wrapperHOC";
import { useResponsiveness } from "hooks/useResponsiveness";
import { memo } from "react";
import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import useTranslationHook from "hooks/useTranslationHook";

import { useSelector } from "react-redux";
import { AppState } from "@Store/index";

const LeadFormLayout = loadable(() => import("@Components/LeadForm/LeadFormLayout"), {
  fallback: <FullPageLoader width="100%" height="100%" />,
});

const SearchLeadFormSection = () => {
  const showGenericForm = useSelector((state: AppState) => state.leadFormModal.showGenericForm);
  const { isBelow } = useResponsiveness();
  const isMobile = isBelow("sm");
  const { t } = useTranslationHook();

  if (!showGenericForm) {
    return null;
  }

  return (
    <section className={styles.sectionWrapper}>
      {/* Image Section - First in JSX for mobile stacking */}
      <div className={styles.imageSection}>
        <Image
          src={
            isMobile
              ? "https://prod-static-assets.amberstudent.com/images/leadformmbcl.png?auto=format"
              : "https://prod-static-assets.amberstudent.com/images/leadformdeskcl.png?auto=format"
          }
          alt="Lead Form Banner"
          className={styles.bannerImage}
          width="100%"
          height="100%"
        />
      </div>

      <div className={styles.contentContainer}>
        {/* Title and Description */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{t("searchpage.components.searchleadformsection.title")}</h2>
          <p className={styles.description}>
            {t("searchpage.components.searchleadformsection.description")}
          </p>
        </div>

        {/* Lead Form */}
        <div className={styles.formWrapper}>
          <LeadFormLayout fromSearchRegionPage isSearchLeadFormSection hideHeader />
        </div>
      </div>
      {/* Bottom separator for mobile */}
      <div className={styles.bottomBorder} aria-hidden="true" />
    </section>
  );
};

export default wrapperHOC(memo(SearchLeadFormSection), {
  componentName: "SearchLeadFormSection",
  showForChina: true,
});
